import { makeStyles } from '@material-ui/core';

const useMpinStyles = makeStyles((theme) => ({
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f1f3f6',
        padding: 24,
    },
    card: {
        width: 440,
        maxWidth: '100%',
        backgroundColor: '#fff',
        borderRadius: 16,
        border: '1px solid rgba(38, 50, 56, 0.08)',
        boxShadow: '0 12px 32px rgba(20, 17, 45, 0.08)',
        padding: '40px 40px 28px',
        position: 'relative',
        overflow: 'hidden',
    },
    resolveBar: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
    },
    brandRow: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 20,
    },
    iconBadge: {
        width: 56,
        height: 56,
        borderRadius: 16,
        backgroundColor: 'rgba(67, 65, 158, 0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#43419e',
    },
    avatar: {
        width: 56,
        height: 56,
        borderRadius: 16,
        backgroundColor: 'rgba(67, 65, 158, 0.10)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#43419e',
        fontSize: 20,
        fontWeight: 700,
        fontFamily: 'Nunito',
    },
    title: {
        fontFamily: 'Nunito',
        fontWeight: 700,
        fontSize: 24,
        color: '#14112d',
        textAlign: 'center',
    },
    subtitle: {
        fontFamily: 'Nunito',
        fontSize: 14,
        color: '#5c6470',
        textAlign: 'center',
        marginTop: 4,
        marginBottom: 24,
    },
    banner: {
        backgroundColor: 'rgba(27, 181, 92, 0.10)',
        border: '1px solid rgba(27, 181, 92, 0.28)',
        borderRadius: 8,
        padding: '10px 14px',
        marginBottom: 20,
        fontFamily: 'Nunito',
        fontSize: 13,
        color: '#14532d',
    },
    fieldBlock: {
        marginBottom: 20,
    },
    fieldLabel: {
        fontFamily: 'Nunito',
        fontSize: 13,
        fontWeight: 700,
        color: '#3d4757',
        marginBottom: 8,
        display: 'block',
    },
    // Ported from Login.tsx's otpInputStyle so both auth steps feel the same.
    otpInputStyle: {
        width: '48px !important',
        height: '48px !important',
        borderRadius: 8,
        border: '1px solid rgba(38, 50, 56, 0.16)',
        fontSize: 24,
        fontWeight: 600,
        fontFamily: 'Nunito',
        '&:focus': {
            outline: 'none',
            border: '1.5px solid #43419e',
        },
    },
    otpError: {
        border: '1px solid #d32f2f !important',
    },
    fieldError: {
        fontFamily: 'Nunito',
        fontSize: 12.5,
        fontWeight: 600,
        color: '#d32f2f',
        marginTop: 8,
    },
    attemptsCaption: {
        fontFamily: 'Nunito',
        fontSize: 12.5,
        fontWeight: 700,
        color: '#b45309',
        marginBottom: 12,
    },
    forgotLink: {
        fontFamily: 'Nunito',
        fontSize: 13,
        fontWeight: 700,
        color: '#43419e',
        marginTop: 10,
        padding: 0,
        textTransform: 'none',
        justifyContent: 'flex-start',
        minWidth: 0,
        '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
        },
    },
    cta: {
        width: '100%',
        height: 46,
        borderRadius: 8,
        textTransform: 'none',
        fontFamily: 'Nunito',
        fontWeight: 700,
        fontSize: 15,
        boxShadow: 'none',
        marginTop: 4,
    },
    // The common error surface — server messages that don't belong to one
    // specific input render here, styled as an alert so they read as the
    // outcome of the submit rather than a stray field hint.
    formError: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        backgroundColor: '#fdecea',
        border: '1px solid rgba(211, 47, 47, 0.25)',
        borderRadius: 8,
        padding: '10px 14px',
        marginBottom: 16,
    },
    formErrorIcon: {
        color: '#d32f2f',
        fontSize: 18,
        marginTop: 1,
    },
    formErrorText: {
        fontFamily: 'Nunito',
        fontSize: 13,
        fontWeight: 600,
        color: '#7a2d2d',
    },
    footer: {
        borderTop: '1px solid rgba(38, 50, 56, 0.08)',
        marginTop: 24,
        paddingTop: 14,
        display: 'flex',
        justifyContent: 'center',
    },
    footerLink: {
        fontFamily: 'Nunito',
        fontSize: 13,
        fontWeight: 700,
        color: '#5c6470',
        textTransform: 'none',
        '&:hover': { backgroundColor: 'transparent', color: '#43419e' },
    },
    lockoutPanel: {
        backgroundColor: '#fdecea',
        border: '1px solid rgba(211, 47, 47, 0.25)',
        borderRadius: 12,
        padding: '20px 24px',
        textAlign: 'center',
        marginBottom: 8,
    },
    lockoutTitle: {
        fontFamily: 'Nunito',
        fontWeight: 700,
        fontSize: 16,
        color: '#c62828',
    },
    lockoutTimer: {
        fontFamily: 'Nunito',
        fontWeight: 700,
        fontSize: 34,
        color: '#14112d',
        margin: '10px 0 6px',
        fontVariantNumeric: 'tabular-nums',
    },
    lockoutMessage: {
        fontFamily: 'Nunito',
        fontSize: 13,
        color: '#7a2d2d',
    },
    lockoutHint: {
        fontFamily: 'Nunito',
        fontSize: 12.5,
        color: '#5c6470',
        marginTop: 10,
    },
    successBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '28px 0 20px',
    },
    successCircle: {
        width: 72,
        height: 72,
        borderRadius: '50%',
        backgroundColor: '#1bb55c',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 16,
    },
    successTitle: {
        fontFamily: 'Nunito',
        fontWeight: 700,
        fontSize: 22,
        color: '#14112d',
    },
}));

export default useMpinStyles;
